import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { getCategoryCount } from "@/utils/video";

export default function CategoryGrid() {
  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
      {categories.map((category) => (
        <Link
          key={category.slug}
          to={`/category/${category.slug}`}
          className="group flex items-start gap-4 rounded-lg border border-background-800 bg-background-900 p-5 transition-colors duration-300 hover:border-primary-700"
        >
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-950 text-primary-300 transition-colors duration-300 group-hover:bg-primary-900">
            <i className={`${category.icon} text-xl`} />
          </span>
          <div className="min-w-0 flex-1">
            <div className="flex items-center justify-between gap-2">
              <h3 className="font-heading text-[15px] font-semibold text-foreground-50 transition-colors group-hover:text-primary-200">
                {category.name}
              </h3>
              <span className="whitespace-nowrap text-[11px] tabular-nums text-foreground-500">
                {getCategoryCount(category.slug)} 部
              </span>
            </div>
            <p className="mt-1.5 truncate text-xs text-foreground-500">{category.summary}</p>
          </div>
          <span className="mt-1 flex h-5 w-5 shrink-0 items-center justify-center text-foreground-600 transition-all duration-300 group-hover:translate-x-0.5 group-hover:text-primary-300">
            <i className="ri-arrow-right-up-line text-base" />
          </span>
        </Link>
      ))}
    </div>
  );
}